import {
    RANGEHOOD,
    useAddApplianceMutation,
} from 'components/customer/Product/store/productApi';
import {useFormikContext} from 'formik';
import React, {useEffect, useRef, useState} from 'react';
import {useConfirmationDialog} from 'shared/components/ConfirmationDialog/ConfirmationDialog';
import {NewApplianceForm} from 'shared/components/Forms/NewApplianceForm';

export const useAppliance = (type: number, name: string) => {
    const [addAppliance] = useAddApplianceMutation();

    const {setFieldValue} = useFormikContext();
    const {dialog, showDialog, hideDialog, setMessage} =
        useConfirmationDialog();
    const newAppliance = useRef({
        make: '',
        model: '',
        height: type == RANGEHOOD ? undefined : 0,
        width: type == RANGEHOOD ? undefined : 0,
        depth: type == RANGEHOOD ? undefined : 0,
        type,
    });
    const [messages, setMessages] = useState<string[]>([]);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        setMessage(
            <NewApplianceForm newAppliance={newAppliance} messages={messages} />
        );
    }, [messages]);

    const buttonClickHandher = () => {
        showDialog({
            title: 'Add new Appliance',
            message: (
                <NewApplianceForm
                    newAppliance={newAppliance}
                    messages={messages}
                />
            ),
            hideYesButton: true,
            hideNoButton: true,
            buttons: [
                {
                    name: 'Save',
                    variant: 'primary',
                    action: async () => {
                        if (newAppliance.current.make === '') {
                            setMessages(['Please enter appliance make']);

                            return;
                        }

                        if (newAppliance.current.model === '') {
                            setMessages(['Please enter a model']);

                            return;
                        }

                        if (
                            type != RANGEHOOD &&
                            newAppliance.current.height &&
                            newAppliance.current.height <= 0
                        ) {
                            setMessages(['Please enter a valid height']);

                            return;
                        }

                        if (
                            type != RANGEHOOD &&
                            newAppliance.current.width &&
                            newAppliance.current.width <= 0
                        ) {
                            setMessages(['Please enter a valid width']);

                            return;
                        }

                        if (
                            type != RANGEHOOD &&
                            newAppliance.current.depth &&
                            newAppliance.current.depth <= 0
                        ) {
                            setMessages(['Please enter a valid depth']);

                            return;
                        }

                        setLoader(true);
                        const response = await addAppliance({
                            ...newAppliance.current,
                            ...{type},
                        });

                        if ('data' in response) {
                            void setFieldValue(name, response.data);
                        }

                        newAppliance.current = {
                            type,
                            make: '',
                            model: '',
                            height: type == RANGEHOOD ? undefined : 0,
                            width: type == RANGEHOOD ? undefined : 0,
                            depth: type == RANGEHOOD ? undefined : 0,
                        };
                        setMessages([]);
                        setLoader(false);
                        hideDialog();
                    },
                    show: true,
                    controlledHideDialog: true,
                },
                {
                    name: 'Cancel',
                    variant: 'warning',
                    show: true,
                },
            ],
        });
    };

    return {
        loader,
        dialog,
        buttonClickHandher,
    };
};
